var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Popup',{attrs:{"showOkButton":false,"errorMsg":_vm.error},on:{"close":_vm.closed}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("Transbank")])]),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{attrs:{"id":"transbank-loader"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }